export default __webpack_public_path__ + "static/media/MainPage.cd9eb422.svg";